import { PhoneArrowUpRightIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { RiWhatsappLine } from "react-icons/ri";

import { CAMPAIGN_TYPE } from "V2.0/HomePages/HomeCampaign/SingleCampaignAdd";

export const CampaignTypeIcons = {
  [CAMPAIGN_TYPE.SMS]: <EnvelopeIcon className="size-5 hover:text-zinc-100" />,
  [CAMPAIGN_TYPE.CALL]: (
    <PhoneArrowUpRightIcon className="size-5" />
  ),
  [CAMPAIGN_TYPE.WHATSAPP]: (
    <RiWhatsappLine className="size-5" />
  ),
};
